"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WHATSAPP_MESSAGE_TYPES = void 0;
exports.getWhatsAppReactionText = getWhatsAppReactionText;
exports.getWhatsAppUnsupportedMessageText = getWhatsAppUnsupportedMessageText;
exports.WHATSAPP_MESSAGE_TYPES = [
    'text',
    'button_reply',
    'template',
    'image',
    'audio',
    'video',
    'document',
    'sticker',
    'location',
    'contacts',
    'reaction',
    'unknown',
];
function getWhatsAppReactionText(reaction) {
    if (!reaction)
        return 'התקבלה תגובה להודעה, אך האימוג׳י לא נשמר.';
    return reaction.emoji === '' ? 'התגובה להודעה הוסרה.' : `תגובה להודעה: ${reaction.emoji}`;
}
const UNSUPPORTED_WHATSAPP_LABELS = new Map([
    ['image', 'תמונה'], ['audio', 'הודעה קולית'], ['video', 'וידאו'], ['document', 'מסמך'],
    ['sticker', 'סטיקר'], ['location', 'מיקום'], ['contacts', 'פרטי איש קשר'],
]);
function getWhatsAppUnsupportedMessageText(type) {
    if (type === 'reaction')
        return getWhatsAppReactionText();
    const label = type && UNSUPPORTED_WHATSAPP_LABELS.get(type);
    return label
        ? `${label}: התוכן אינו זמין להצגה באפליקציה.`
        : 'התקבלה הודעה בפורמט שעדיין לא ניתן להציג באפליקציה.';
}
